
import { mapActions, mapGetters } from 'vuex'
import EnerDownloadFloatingButton from '@/components/ui/enerDownloadFloatingButton'
import { htmlize } from '@/utils/StringUtils'
import DataContent from '@/components/page/dataContent'
import CountrySnapshotContent from '@/components/page/countrySnapshotContent'

export default {
  components: { CountrySnapshotContent, DataContent, EnerDownloadFloatingButton },
  beforeRouteUpdate (to, from, next) {
    this.clearMapRegion()
    this.clearBenchmarkRegions()
    next()
  },
  beforeRouteLeave (to, from, next) {
    this.clearMapRegion()
    this.clearBenchmarkRegions()
    next()
  },
  validate ({ params }) {
    return /.html$/.test(params.page)
  },
  data () {
    return {
      values: []
    }
  },
  head () {
    const i18nHead = this.$nuxtI18nHead({ addSeoAttributes: true })
    return {
      title: this.pageContent.seo.title,
      htmlAttrs: {
        ...i18nHead.htmlAttrs
      },
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.pageContent.seo.description
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: this.pageContent.seo.keywords
        },
        {
          property: 'og:type',
          content: 'website'
        },
        {
          property: 'og:title',
          content: this.pageContent.seo.title
        },
        {
          property: 'og:url',
          content: 'https://' + this.$i18n.localeProperties.domain + this.$route.fullPath
        },
        {
          property: 'og:description',
          content: this.pageContent.seo.description
        },
        {
          property: 'twitter:card',
          content: 'summary'
        },
        {
          property: 'twitter:site',
          content: '@Enerdata'
        },
        {
          property: 'twitter:title',
          content: this.pageContent.seo.title
        },
        {
          property: 'twitter:description',
          content: this.pageContent.seo.description
        },
        ...i18nHead.meta
      ],
      link: [
        ...this.injectAlternateLinkHrefs(i18nHead.link)
      ]
    }
  },
  computed: {
    ...mapGetters({
      pageType: 'page/pageType',
      world: 'world',
      pages: 'pages',
      pageContent: 'page/pageContent',
      isMobileLayout: 'isMobileLayout'
    }),
    pageLandscapeImage () {
      return require(`@/assets/images/jumbotron/${this.pageContent.jumbotron}.jpg`)
    }
  },
  methods: {
    ...mapActions({
      clearPageContent: 'page/clearPageContent',
      clearMapRegion: 'page/clearMapRegion',
      clearBenchmarkRegions: 'page/clearBenchmarkRegions'
    }),
    injectAlternateLinkHrefs (links) {
      // generate alternate link not well managed by nuxt-i18n cause based on page json
      const locales = this.$i18n.locales
      const n = locales.length
      let linkList = []
      for (let i = 0; i < n; i++) {
        const locale = locales[i]
        const pageData = this.pages.find(page => this.pageContent.id === page.id)
        linkList.push({
          hid: `i18n-alt-${locale.iso}`,
          rel: 'alternate',
          href: 'https://' + locale.domain + '/' + pageData.url + '.html',
          hreflang: locale.iso
        })
      }
      // retrieve all non alternate link generated by nuxt-i18n (mainly canonical)
      const extraLinks = links.filter(link => link.rel !== 'alternate')
      if (extraLinks.length > 0) {
        linkList = linkList.concat(extraLinks)
      }
      return linkList
    },
    htmlize (text) {
      return htmlize(text)
    }
  }
}
